import * as Yup from "yup";
import Modal from "../Modal/Modal";
import { useFormik } from "formik";
import OTP from "../../Formik/OTP/OTP";
import Button from "../../Button/Button";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Select from "../../Formik/Select/Select";
import styles from "./CancelCardModal.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { SERVICESTYPE } from "../../../../utils/constants";
import InputFormik from "../../Formik/Input/InputFormik";
import { cancelCardAction, cardDetailsAction, generateOTPAction, getCryptoByFilterAction } from "../../../../features/user/userSlice";
import emailStyles from "../../../../components/pages/OnboardScreens/EmailVerification/EmailVerification.module.scss";
import { useNavigate } from "react-router-dom";


const CancelCardModal = ({ show, handleClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [timer, setTimer] = useState(60);
  const [seconds, setSeconds] = useState();
  const [loading, setLoading] = useState(false);
  const [showBtn, setShowBtn] = useState(false);
  const [options, setOptions] = useState([]);
  const [cardDetails, setCardDetails] = useState({});
  const cardType = localStorage.getItem("cardType")
  const userData = useSelector((state) => state?.persist?.userInfo);

  const formik = useFormik({
    initialValues: {
      reason: "",
      coin: null,
      otp: "",
    },

    validationSchema: Yup.object({
      reason: Yup.string()
        .min(3, "Reason must be at least 3 characters")
        .max(50),

      coin: Yup.object()
        .nullable()
        .required("Please select a coin"),

      otp: Yup.string()
        .required("OTP is required")
        .matches(/^[0-9]{6}$/, "OTP must be 6 digits"),
    }),

    onSubmit: (values) => {
      handleSubmit(values)
    },
  });


  useEffect(() => {
    if (!show) {
      formik.resetForm();
    }
  }, [show]);

  const generateOTP = async () => {
    const data = {
      username: await userData?.email,
      type: SERVICESTYPE?.EMAIL,
      service: "CARD_CANCEL",
    };
    try {
      const response = await dispatch(generateOTPAction(data));
      if (response?.status === 200) {
        reSetTime();
      }
    } catch (error) {
      console.log("Something went wrong:", error);
    }
  };

  const setTime = () => {
    if (!seconds || seconds > 0) {
      const timer = setInterval(() => {
        setSeconds((second) => {
          if (second <= 0) {
            return clearInterval(timer);
          }
          return second - 1;
        });
      }, 1000);
    }
  };

  const reSetTime = () => {
    setSeconds(180); // 3 minutes in seconds
    setTime();
  };

  const handleResend = () => {
    formik.setFieldValue("otp", "");
    generateOTP();
    setTimer(56);  // reset timer
    setShowBtn(false);
  };

  useEffect(() => {
    generateOTP()
  }, [])

  useEffect(() => {
    let interval;

    if (timer > 0) {
      setShowBtn(false);
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      setShowBtn(true);
    }

    return () => clearInterval(interval);
  }, [timer]);

  /* ===================== FETCH COINS ===================== */
  const getCryptoOptions = async () => {
    try {
      const res = await dispatch(getCryptoByFilterAction({ filter: cardType === "DEBIT" ? "stableCoin" : "nativeCoin" }))
      if (res?.status === 200 || res?.status === 201) {
        const options = res?.data?.data?.map((item) => ({
          value: cardType === "DEBIT" ? item?.symbol : item?.id,
          label: item?.name,
        }));
        setOptions(options || [])
      } else {
        console.log("API ERROR");
      }
    } catch (error) {
      console.log(error, "error");

    }
  }

  useEffect(() => {
    getCryptoOptions();
    getCardDetails();
  }, []);

  // ********** GET CARD DETAILS **********
  const getCardDetails = async () => {
    try {
      const res = await dispatch(cardDetailsAction());
      if (res?.status === 200) {
        const cards = res?.data?.data || [];
        const debit = cards.find((c) => c.card_type === "DEBIT");
        const credit = cards.find((c) => c.card_type === "CREDIT");
        setCardDetails({ debit: debit, credit: credit })
      } else {
        setCardDetails({});
      }
    } catch (error) {
      console.log(error, "error");
    }
  }
  const cardId = cardType === "CREDIT" ? cardDetails?.credit?.rain_card_id : cardDetails?.debit?.rain_card_id;


  const handleSubmit = async (values) => {
    try {
      setLoading(true)
      const payload = {
        otp: values?.otp,
        reason: values?.reason,
        status: "canceled",
        ...(cardType === "DEBIT" && {
          coin: values?.coin?.value,
        }),
        ...(cardType === "CREDIT" && {
          tokenId: values?.coin?.value,
        }),
      };
      const res = await dispatch(cancelCardAction(cardId, payload))
      if (res?.status === 200 || res?.status === 201) {
        handleClose()
        navigate('/auth/apply-card')
      }
    } catch (error) {
      console.log(error, "error");
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      show={show}
      handleClose={handleClose}
      title={"Cancel Card"}
      // hideCloseBtn
      className={styles.add_pin_modal}
    >
      <form onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
        {/* ===================== AMOUNT INPUT ===================== */}
        <Row>
          <Col lg={12} className="mb-3">
            <InputFormik
              variant="large_height"
              name="reason"
              label="Reason"
              placeholder="Enter reason"
              className="fieldinput"
              {...formik.getFieldProps("reason")}
              formik={formik}
            />
          </Col>

          {/* ===================== COIN SELECT ===================== */}
          <Col lg={12} className="mb-4">
            <Select
              variant="xlarge_height"
              className="select_time"
              label="Select Coin"
              name="coin"
              options={options}
              value={formik.values.coin}
              onChange={(option) =>
                formik.setFieldValue("coin", option)
              }
              isSearchable={false}
              placeholder={"Select coin"}
            />
          </Col>
        </Row>
        <OTP
          label="Enter OTP"
          name="otp"
          value={formik.values.otp}
          onChange={(value) => {
            formik.setFieldValue("otp", value);
          }}
          onBlur={formik.handleBlur}
          formik={formik}
          placeholder="------"
        />
        <div className={emailStyles.btn_restotp}>
          {showBtn ? (
            <Button
              className={` ${emailStyles.restBtn}`}
              onClick={handleResend}
              type="button"
              variant="without_bg_border"
            >
              Re send
            </Button>
          ) : (
            <p>Re send verification code in {timer}s</p>
          )}
        </div>
        <Button
          fluid
          className={styles.btn_pin}
          type="button"
          disabled={loading}
          onClick={(e) => {
            formik.handleSubmit(e);
          }}
        >
          {loading ? "Loading..." : "Continue"}
        </Button>
      </form>
    </Modal >
  );
};

export default CancelCardModal;
